const PROD_BOT_ID = '67cc2842c7a21d8e097693d7';
const TEST_BOT_ID = '6a0c5bac288007697f56b558';
const LOCAL_BOT_ID = '67978d1f12e4de13749b2376';
const PROD_PORTAL = 'https://app.hugo.legal/hugoapp';
const TEST_PORTAL = 'https://clienttest.hugo.legal/hugoapp';
const LOCAL_PORTAL = 'http://localhost:3001/hugoapp';

function isLocalHostName(hostname) {
	return hostname === 'localhost' || hostname === '127.0.0.1';
}

/** True when API or browser host is the apptest / clienttest stack. */
export function isTestEnvironment() {
	const apiBase = process.env.REACT_APP_BASE_URL || '';
	if (apiBase.includes('apptest')) {
		return true;
	}
	if (typeof window !== 'undefined') {
		const host = window.location.hostname;
		if (host.includes('apptest') || host === 'clienttest.hugo.legal') {
			return true;
		}
	}
	return false;
}

/** True when CRM uses a local API or runs in the browser on localhost (and not apptest). */
export function isLocalEnvironment() {
	if (isTestEnvironment()) {
		return false;
	}
	const apiBase = process.env.REACT_APP_BASE_URL || '';
	if (apiBase.includes('localhost') || apiBase.includes('127.0.0.1')) {
		return true;
	}
	if (typeof window !== 'undefined') {
		return isLocalHostName(window.location.hostname);
	}
	return false;
}

/** @returns {'test' | 'local' | 'prod'} */
export function getPaymentEnvironment() {
	if (isTestEnvironment()) {
		return 'test';
	}
	if (isLocalEnvironment()) {
		return 'local';
	}
	return 'prod';
}

export function getPaymentBotId() {
	const env = getPaymentEnvironment();
	if (env === 'test') {
		return TEST_BOT_ID;
	}
	if (env === 'local') {
		return LOCAL_BOT_ID;
	}
	return PROD_BOT_ID;
}

export function getPaymentPortalBaseUrl() {
	const env = getPaymentEnvironment();
	if (env === 'test') {
		return TEST_PORTAL;
	}
	if (env === 'local') {
		return LOCAL_PORTAL;
	}
	return PROD_PORTAL;
}

export function buildInvoicePaymentLink(invoiceId) {
	return `${getPaymentPortalBaseUrl()}?bot=${getPaymentBotId()}&invoice_id=${invoiceId}`;
}

/** Preview URL base for chatbot builder / apps list (uses the chatbot id, not payment bot). */
export function getChatbotPreviewBaseUrl() {
	const env = getPaymentEnvironment();
	if (env === 'test') {
		return `${TEST_PORTAL}?bot=`;
	}
	if (env === 'local') {
		return `${LOCAL_PORTAL}?bot=`;
	}
	return `${PROD_PORTAL}?bot=`;
}

export function buildChatbotPreviewUrl(botId) {
	return `${getChatbotPreviewBaseUrl()}${botId}`;
}
